import React from 'react'
import tw, {styled} from 'twin.macro'
import Link from 'gatsby-link'
import {GatsbyImage} from 'gatsby-plugin-image'

const Wrapper = styled.div`
  ${tw`bg-gray-dark grid grid-cols-2 py-10 px-6 md:(py-10 px-12 grid grid-cols-12)`}
`

const Text = styled.div`
  ${tw`block pl-4 md:pl-8`}
`

const Title = styled.h3`
  ${tw`block text-base mb-4 leading-4 md:text-2xl md:leading-tight`}
`

const SubTitle = styled.span`
  ${tw`block text-xs mt-4 text-white text-opacity-90 font-bold tracking-wider uppercase`}
`

const EventDate = styled.span`
  ${tw`block text-xs mt-4 text-white text-opacity-90 font-bold `}
`

const StyledLink = styled(Link)`
  ${tw`h-52 md:h-64 grid items-center grid-cols-2  col-start-3 col-span-8
  p-8 rounded-2xl overflow-hidden
  no-underline transition-colors duration-300 text-white text-opacity-90 hover:text-opacity-100 md:() lg:(col-start-4 col-span-6)`}

  &:hover {
    ${tw`text-white text-opacity-100`}
  }
  @media (hover: none) {
    ${tw`text-white text-opacity-90`}
  }
`

const Preview = (props) => {
  return (
    <>
      {props.post && (
        <Wrapper>
          <StyledLink
            className="group"
            to={`/${props.post.sys.contentType.sys.id}/${props.post.slug}/`}
          >
            {props.post.cover && (
              <GatsbyImage
                tw="-ml-8 -my-8"
                image={props.post.cover.gatsbyImageData}
                alt={props.post.cover.title}
              />
            )}
            <Text>
              <SubTitle>More</SubTitle>
              <Title>{props.post.title}</Title>
            </Text>
          </StyledLink>
        </Wrapper>
      )}
    </>
  )
}

export default Preview
